import React from 'react';
import Icon from '../../../components/AppIcon';
import { chatbotService } from '../../../services/chatbotService';

const QuickActionButtons = ({ onSelectPrompt, compact = false }) => {
  const quickActions = chatbotService?.getQuickActionPrompts();

  if (compact) {
    return (
      <div className="flex flex-wrap gap-2">
        {quickActions?.slice(0, 2)?.map((category) => (
          category?.prompts?.slice(0, 1)?.map((prompt, idx) => (
            <button
              key={`${category?.category}-${idx}`}
              onClick={() => onSelectPrompt?.(prompt)}
              className="px-3 py-1.5 text-sm bg-primary/10 hover:bg-primary/20 text-primary rounded-full transition-colors"
            >
              {prompt}
            </button>
          ))
        ))}
      </div>
    );
  }

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-4 max-w-4xl">
      {quickActions?.map((category) => (
        <div key={category?.category} className="space-y-2">
          <h4 className="text-sm font-semibold text-foreground flex items-center gap-2">
            <Icon 
              name={
                category?.category === 'Workout Guidance' ? 'Dumbbell' :
                category?.category === 'Nutrition Advice' ? 'Apple' :
                category?.category === 'Technical Support'? 'HelpCircle' : 'Zap'
              } 
              size={16} 
              className="text-primary" 
            />
            {category?.category}
          </h4>
          <div className="space-y-2">
            {category?.prompts?.map((prompt, idx) => (
              <button
                key={idx}
                onClick={() => onSelectPrompt?.(prompt)}
                className="w-full text-left px-4 py-2 text-sm bg-muted hover:bg-muted/80 text-foreground rounded-lg transition-colors border border-border hover:border-primary"
              >
                {prompt}
              </button>
            ))}
          </div>
        </div>
      ))}
    </div>
  );
};

export default QuickActionButtons;